import {useQuery} from 'react-query';
import {fetchProjectStats} from '../api/reportsApi';

export function useProjectStats(token, timeRange, date = null) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    return useQuery({
        queryKey: ['project-stats', timeRange, timezone, date, token],
        queryFn: () => fetchProjectStats(token, timeRange, timezone, date),
        enabled: !!token && !!timeRange,
    });
}
